import React from "react"
import Toast from "./toast"
import { StyledToastsContainer } from "./styles"

const ToastsContainer = ({ toasts, removeToast }) =>
  toasts.length > 0 && (
    <StyledToastsContainer>
      {toasts.map((toast) => (
        <Toast key={toast.id} {...toast} removeToast={removeToast} duration={3000} />
      ))}
    </StyledToastsContainer>
  )

export default ToastsContainer
